import { FlowButtons } from 'src/app/shared/base/FlowButtons';
import { FlowStepBaseComponent } from 'src/app/shared/base/FlowStepBaseComponent';

export abstract class ReviewFlowStepBaseComponent extends FlowStepBaseComponent {
  buttons: FlowButtons;
}
